import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrInfo } from '../../../../../../shared/types/modules/pqr';
import { PqrInfoProps } from './props';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../../../../services/param.service';
import {
    asyncGetCities,
    asyncGetCountries,
    asyncGetCountryByCode,
} from '../../../../../../services/location.service';

export const usePqrInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrInfoProps) => {
    const [status, setStatus] = useState<ISelect[]>([]);
    const [countries, setCountries] = useState<ISelect[]>([]);
    const [locations, setlocations] = useState<ISelect[]>([]);
    const [defaultCountry, setDefaultCountry] = useState<ISelect>();

    const onSubmit = (data: PqrInfo) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(
            (defaultCountry?.id as string) || ''
        ),
        onSubmit,
    });

    const isColombiaCountry = formik?.values?.country === defaultCountry?.id;

    const getStatus = (statusCode?: string) => {
        statusCode = statusCode || `${ParamEnum.PQR_STATUS}_ABI`;

        asyncGetParamByCode(statusCode).then((item) => {
            setStatus(item ? [item] : []);
            formik.setFieldValue('status', item?.id);
        });
    };

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setStatus(
                params?.filter(
                    (param) => param.code !== `${ParamEnum.PQR_STATUS}_REP`
                )
            )
        );
        formik?.setFieldValue('status', data?.status || '');
        formik?.setFieldValue('country', data?.country || defaultCountry?.id);
        formik?.setFieldValue('location', data?.location || '');
        formik?.setFieldValue(
            'correspondenceFiling',
            data?.correspondenceFiling || ''
        );
        formik?.setFieldValue('detail', data?.detail || '');
    }, [data, defaultCountry]);

    useEffect(() => {
        getStatus();
        asyncGetCountries().then((items) => setCountries(items));
        asyncGetCities().then((items) => setlocations(items));
        asyncGetCountryByCode('170').then((item) => setDefaultCountry(item));
    }, []);

    return {
        formik,
        status,
        countries,
        locations,
        isColombiaCountry,
    };
};
